"use client";

import { ApiAuth } from "@/api/auth";
import { FC, ReactNode, useEffect, useRef } from "react";
import { usePathname, useRouter } from "next/navigation";
import { AuthConfirmResource } from "@/api/generated-api";

interface ConfirmProviderProps {
  children: ReactNode;
}

const ConfirmProvider: FC<ConfirmProviderProps> = ({ children }) => {
  const router = useRouter();
  const pathname = usePathname();
  const processedRef = useRef<Set<string>>(new Set());

  useEffect(() => {
    if (typeof window === "undefined") return;

    const currentParams = new URLSearchParams(window.location.search);
    const email = currentParams.get("email");
    const type = currentParams.get("type");
    const hash = currentParams.get("hash");

    if (!email || !type || !hash) return;

    const payloadKey = `${email}:${type}:${hash}`;
    if (processedRef.current.has(payloadKey)) return;
    processedRef.current.add(payloadKey);

    const payload: AuthConfirmResource = { email, type, hash };

    const nextParams = new URLSearchParams(window.location.search);
    nextParams.delete("email");
    nextParams.delete("type");
    nextParams.delete("hash");

    const cleanedQuery = nextParams.toString();
    const nextUrl = cleanedQuery ? `${pathname}?${cleanedQuery}` : pathname;

    router.replace(nextUrl, { scroll: false });

    ApiAuth.confirm(payload).catch(() => {
      processedRef.current.delete(payloadKey);
    });
  }, [pathname, router]);

  return <>{children}</>;
};

export default ConfirmProvider;
